// Client-side CSV export for widget data.

const cell = (v) => {
  let s = v === null || v === undefined ? "" : String(v);
  if (/^[=+\-@]/.test(s)) s = `'${s}`;
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

/**
 * CSV text from columns + row objects (formula-injection safe). `meta` rows
 * ([field, value]) go first, each prefixed "#", then a blank line, so the file
 * says what was counted and still opens as a plain table below.
 */
export function toCsv(columns, rows, { meta = [] } = {}) {
  const head = meta.length ? [...meta.map(([k, v]) => [cell(`# ${k}`), cell(v)].join(",")), ""] : [];
  return [...head, columns.map((c) => cell(c.label)).join(","), ...rows.map((r) => columns.map((c) => cell(r[c.key])).join(","))].join("\r\n");
}

export function downloadCsv(filename, text) {
  const href = URL.createObjectURL(new Blob([text], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(href), 1000);
}
